import Select, { SelectProps } from 'antd/es/select';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import styles from './AdAudienceSelect.module.css';
import { selectFacebookAdAudiences } from '@mm/state/selectors/adAudiencesSelector';
import { useAdAudienceCRUDActions } from '@mm/state/actions/AdAudienceCRUDActions';
import AdAudienceModel from '@mm/state/model/AdAudienceModel';

export const AdAudienceSelect = ({
  onChange,
  selectedAdAudienceId,
  className,
  ...rest
}: {
  className?: string;
  onChange: (audienceId: number, audience: AdAudienceModel) => void;
  selectedAdAudienceId?: number | null;
} & Partial<SelectProps<number | null | undefined, AdAudienceModel>>) => {
  const audiences = useSelector(selectFacebookAdAudiences);
  const botId = useSelector(activeChatbotIdSelector);

  const adAudienceCRUDActions = useAdAudienceCRUDActions();

  const handleChange = (audienceId: number, adAudience: AdAudienceModel) => {
    onChange(Number(audienceId), adAudience);
  };

  const options = audiences.map(audience => ({
    value: audience.id,
    label: audience.name,
    ...audience,
  }));

  useEffect(() => {
    const match = audiences.find(v => v.id === selectedAdAudienceId);
    if (!match && selectedAdAudienceId) {
      adAudienceCRUDActions.retrieveAudienceByRemoteId(
        botId,
        selectedAdAudienceId,
      );
    }
  }, []);

  return (
    <Select
      className={className}
      defaultValue={selectedAdAudienceId}
      placeholder="Choose Facebook Ad Audience"
      onChange={handleChange}
      options={options}
      popupClassName={styles.popup}
      {...rest}
    />
  );
};
